module.exports = __webpack_public_path__ + "static/media/YF69_2.682d8421.jpg";